module.exports = __webpack_public_path__ + "static/office-inside-wide-292f378e746bf6c2c447c5de2dc0c8dd.jpg";